import { useSEO } from "../lib/seo";

export default function Privacy() {
  useSEO({ title: "Privacy Policy", description: "BeforeExam Privacy Policy" });
  return (
    <div className="container-x py-14 max-w-3xl prose-content" data-testid="privacy-page">
      <h1 className="font-display text-4xl tracking-tighter">Privacy <span className="font-serif text-gradient-gold">Policy</span></h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: February 2026</p>

      <div className="mt-8 space-y-6 text-sm leading-relaxed">
        <Section title="Who we are">
          BeforeExam Labs ("we", "us") provides certification practice-test software at beforeexam.com. We are committed to protecting your personal information.
        </Section>
        <Section title="What we collect">
          When you create an account we collect your name, email address, and (for password auth) a hashed password. When you take practice tests we store your answers, scores, and timing to compute your readiness score. When you make a purchase we store the order metadata (not card numbers — payments are processed by Stripe).
        </Section>
        <Section title="How we use it">
          To run the service, generate analytics for your dashboard, send you transactional emails (purchase receipts, password resets), and — only if you opt in — product updates. We never sell your data.
        </Section>
        <Section title="Cookies">
          We use a single httpOnly authentication cookie. We do not use third-party advertising cookies.
        </Section>
        <Section title="Your rights">
          You can request export or deletion of your data at any time by emailing privacy@beforeexam.com. We respond within 30 days.
        </Section>
        <Section title="Contact">
          Questions? Email privacy@beforeexam.com.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-lg">{title}</h2>
      <p className="mt-2 text-muted-foreground">{children}</p>
    </div>
  );
}
